import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'

import SecurityGroupManager from '../account/components/securityGroupManager'
import Loader from '../common/components/notifications/Loader'
import config from '../config'
import actions from '../redux/actions'
import { GET_USERS } from '../redux/data/types'

const SecurityGroups = props => {
  const { api, requestUsers, sentRequest, pending } = props
  const ref = useRef()
  const getUsers = () => api.users.get({}, (_, res) => {
    // console.log('res:', res)
  })

  const htmlEl = document.documentElement
  useEffect(() => {
    if (ref.current) {
      htmlEl.style.fontSize = 'initial'
    }
    htmlEl.style.fontSize = 'initial'
    return () => {
      // reset html font-size on unmount
      htmlEl.style.fontSize = '10px'
    }
  }, [ref])

  useEffect(() => {
    if (!pending && !sentRequest) {
      getUsers()
      requestUsers()
    }
  }, [pending, sentRequest])

  if (pending || !sentRequest) return <Loader />
  return <SecurityGroupManager api={api} />
}

const SecurityGroupsRoute = (api, socket, opts, match) => {
  return () => {
    const Route = connect(mapStateToProps, mapDispatchToProps, mergeProps)(SecurityGroups)
    return <Route api={api} />
  }
}

const mapStateToProps = state => {
  const clientID = state.data.user.clientId
  const sentRequest = state.request[GET_USERS]
  const pending = state.request[GET_USERS]?.pending || false
  return { clientID, sentRequest, pending }
}

const mapDispatchToProps = dispatch => ({
  callDispatch: func => dispatch(func),
})

const mergeProps = (stateProps, _dispatchProps, ownProps) => {
  const dispatch = func => _dispatchProps.callDispatch(func)
  const requestUsers = () => dispatch(actions.request.sendRequest({
    type: GET_USERS,
    url: `${config.uris.crud}Users/getUsers`,
    postData: {
      clientID: stateProps.clientID
    }
  }))
  return { ...stateProps, requestUsers, ...ownProps }
}

export default SecurityGroupsRoute
